/* COLHIDA — menu do celular + contador da sacola. */
(function () {
  function initHeader() {
    var hd = document.querySelector('[data-clh-header]');
    if (!hd || hd.dataset.clhInit === '1') return;
    hd.dataset.clhInit = '1';

    var btn = hd.querySelector('.clh-hd__toggle');
    var drawer = hd.querySelector('.clh-hd__drawer');
    if (!btn || !drawer) return;

    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      if (open) { drawer.removeAttribute('hidden'); }
      else { drawer.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) btn.click();
    });
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
        });
      })
      .catch(function () { /* silencioso */ });
  }

  document.addEventListener('DOMContentLoaded', initHeader);
  document.addEventListener('shopify:section:load', initHeader);
  document.addEventListener('cart:refresh', refreshCount);
  initHeader();
})();